function swipersInit() {
  const bannerSlider = new Swiper('.swiper-banners', {
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
  },
    loop: $('.swiper-banners').data('length') > 1,
    slidesPerView: 1,
    watchOverflow: true
  })


  const carDropdownCSwiper = new Swiper ('.car-dropdown-c-swiper', {
    slidesPerView: 3,
    spaceBetween: 20,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
  })

  const awardsSwiper = new Swiper ('.awards-swiper', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next.button-next-awards',
      prevEl: '.swiper-button-prev.button-prev-awards',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })

  const catogoriesSwiper = new Swiper ('.categories-swiper', {
    slidesPerView: 3,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next.button-next-category',
      prevEl: '.swiper-button-prev.button-prev-category',
    },
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
    },
  })

  const promotionSwiper = new Swiper ('.promotion-swiper', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next.button-next-promotion',
      prevEl: '.swiper-button-prev.button-prev-promotion',
    },
    breakpoints: {
      700: {
        slidesPerView: 2,
        spaceBetween: 15
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })

  const carVersionSwiper = new Swiper ('.car-version-swiper', {
    slidesPerView: 1,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.button-next-version',
      prevEl: '.swiper-button-prev.button-prev-version',
    },
    breakpoints: {
      1500: {
        slidesPerView: 6,
        spaceBetween: 15
      },
      1050: {
        slidesPerView: 3,
        spaceBetween: 15
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })

  const usedHighlightSwiper = new Swiper('.used-highlights-swiper', {
    slidesPerView: 1,
    watchOverflow :true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.used-highlights-cars',
      prevEl: '.swiper-button-prev.used-highlights-cars',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      900: {
        slidesPerView: $('.used-highlights-swiper').data('slides')
      },
      1600: {
        slidesPerView: $('.used-highlights-swiper').data('slides')
      }
    }
  })

  const newCarsHighlightSwiper = new Swiper('.news-highlights-swiper', {
    slidesPerView: 1,
    // centerInsufficientSlides: true,
    setWrapperSize: true,
    watchOverflow :true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.news-highlights-cars',
      prevEl: '.swiper-button-prev.news-highlights-cars',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
      DynamicMainBullets: 3
    },
    breakpoints: {
      900: {
        slidesPerView: $('.news-highlights-swiper').data('slides')
      },
      1600: {
        slidesPerView: $('.news-highlights-swiper').data('slides') + 1
      }
    }


  })

  const newCarsTabsSwiper = new Swiper('.new-cars-tabs-swiper', {
    slidesPerView: 2,
    centerInsufficientSlides: true,
    watchOverflow :true,
    // spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.new-cars-tabs',
      prevEl: '.swiper-button-prev.new-cars-tabs',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })


  const newCarsSwiper = new Swiper('.new-cars-swiper', {
    slidesPerView: 1,
    // centerInsufficientSlides: true,
    setWrapperSize: true,
    watchOverflow :true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.new-cars',
      prevEl: '.swiper-button-prev.new-cars',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      900: {
        slidesPerView: $('.new-cars-swiper').data('slides')
      },
      1600: {
        slidesPerView: $('.new-cars-swiper').data('slides') + 1
      }
    }


  })

  const directSaleSwiper = new Swiper('.direct-sale-swiper', {
    slidesPerView: 1,
    // centerInsufficientSlides: true,
    watchOverflow :true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.direct-sale',
      prevEl: '.swiper-button-prev.direct-sale',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      900: {
        slidesPerView: $('.direct-sale-swiper').data('slides'),
      },
      1600: {
        slidesPerView: $('.direct-sale-swiper').data('slides') + 1,
      }
    }
  })

  const usedCarsSwiper = new Swiper('.used-cars-swiper', {
    slidesPerView: 1,
    // centerInsufficientSlides: true,
    watchOverflow :true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.used-cars',
      prevEl: '.swiper-button-prev.used-cars',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      900: {
        slidesPerView: $('.used-cars-swiper').data('slides'),
      }
    }
  })

  const localSlider = new Swiper('.local-swiper', {
    slidesPerView: 1,
    spaceBetween: 40,
    navigation: {
        nextEl: '.swiper-button-next.local',
        prevEl: '.swiper-button-prev.local',
    },
    pagination: {
      el: '.swiper-pagination.local',
      clickable: true
  },
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
  })

  const sliderUsedInternalThumbs = new Swiper('.used-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.slider-used-thumb-next',
      prevEl: '.swiper-button-prev.slider-used-thumb-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const sliderUsedInternal = new Swiper('.used-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.slider-used-next',
      prevEl: '.swiper-button-prev.slider-used-prev',
    },
    clickable: true,
    thumbs: {
      swiper: sliderUsedInternalThumbs
    }
  });

  const sliderUsedRelated = new Swiper('.slider-used-related', {
    clickable: true,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination.related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.related',
      prevEl: '.swiper-button-prev.related',
    },
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
  });

  const phonesSwiper = new Swiper('.phones-swiper', {
    slidesPerView: 1,
    loop: true,
    navigation:{
      nextEl: '.swiper-button-next.phones',
      prevEl: '.swiper-button-prev.phones'
    },
    pagination: false,
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    atchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  $('.frick').each(function(){
    new Swiper(this, {
      slidesPerView: 4,
      spaceBetween: 40,
      draggable: true,
      loop: false,
      navigation:{
        nextEl: '.next-' + $(this).data('ref'),
        prevEl: '.prev-' + $(this).data('ref'),
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      watchOverflow: true,
      observer:true,
      observeParents: true,
      observeSlideChildren: true,
      watchOverflow :true,
      atchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
  });

  const versionsSwiper = new Swiper('.versions-swiper', {
    slidesPerView: 1,
    setWrapperSize: true,
    watchOverflow :true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.version-car',
      prevEl: '.swiper-button-prev.version-car',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      900: {
        slidesPerView: $('.versions-swiper').data('slides')
      },
      1600: {
        slidesPerView: $('.versions-swiper').data('slides')
      }
    }

  });


  const loyalty = new Swiper('.loyalty-cards-swiper', {
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      900: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    }
  });

  // const bannerSlider = new Swiper('.swiper-banners', {
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//     },
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true
//   },
//     loop:true,
//     watchOverflow: true
// })


// const carDropdownCSwiper = new Swiper ('.car-dropdown-c-swiper', {
//     slidesPerView: 3,
//     spaceBetween: 30,
//     observer:true,
//     observeParents: true,
//     observeSlideChildren: true,
//     watchOverflow :true,
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true
//     }
// })

// const phoneSlider = new Swiper('.swiper-phones', {
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//     },
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
//     observer: true,
//     observeParents: true,
//     breakpoints: {
//         992: {
//             pagination: {
//                 el: '.swiper-pagination',
//             }
//         }
//     },
//     watchOverflow: true
// })

// const usedSlider = new Swiper('.swiper-used', {
//     spaceBetween: 0,
//     slidesPerView: 1,
//     navigation: {
//         nextEl: '.btn-swiper-used-next',
//         prevEl: '.btn-swiper-used-prev',
//     },
//     breakpoints: {
//         992: {
//             spaceBetween: 30,
//             slidesPerView: 5,
//         }
//     },
//     watchOverflow: true
// })
// const usedRelatedSlider = new Swiper('.swiper-used-related', {
//     spaceBetween: 0,
//     slidesPerView: 1,
//     navigation: {
//         nextEl: '.btn-swiper-used-related-next',
//         prevEl: '.btn-swiper-used-related-prev',
//     },
//     pagination: {
//         el: '.swiper-pagination',
//     },
//     breakpoints: {
//         992: {
//             spaceBetween: 30,
//             slidesPerView: 4
//         }
//     },
//     watchOverflow: true
// })
// const newSlider = new Swiper('.swiper-tabs-new', {
//     slidesPerView: 4,
//     navigation: {
//         nextEl: '.btn-car-tabs-next',
//         prevEl: '.btn-car-tabs-prev'
//     },
//     breakpoints: {
//         992: {
//             slidesPerView: 5
//         }
//     },
//     watchOverflow: true
// })


// const directSalesSlider = new Swiper('.swiper-tabs-direct', {
//     slidesPerView: 3,
//     navigation: {
//         nextEl: '.btn-direct-tabs-next',
//         prevEl: '.btn-direct-tabs-prev'
//     },
//     breakpoints: {
//         992: {
//             slidesPerView: 7
//         }
//     },
//     watchOverflow: true
// })

// const assistSalesSlider = new Swiper('.swiper-tabs-assist', {
//     slidesPerView: 2,
//     navigation: {
//         nextEl: '.btn-direct-tabs-next',
//         prevEl: '.btn-direct-tabs-prev'
//     },
//     breakpoints: {
//         992: {
//             slidesPerView: 6
//         }
//     },
//     watchOverflow: true
// })

// const versionSliderThumbs = new Swiper('.swiper-versions', {
//     slidesPerView: 1,
//     freeMode: true,
//     watchSlidesVisibility: true,
//     watchSlidesProgress: true,
//     breakpoints: {
//         992: {
//             spaceBetween: 30,
//             slidesPerView: 4,
//         }
//     }
// })
// const versionSliderContent = new Swiper('.swiper-versions-content', {
//     navigation: {
//         nextEl: '.btn-swiper-versions-next',
//         prevEl: '.btn-swiper-versions-prev'
//     },
//     thumbs: {
//         swiper: versionSliderThumbs
//     }
// })

// const usedBannerSlider = new Swiper('.swiper-used-highlights', {
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//     },
//     navigation: {
//         nextEl: '.btn-highlight-next',
//         prevEl: '.btn-highlight-prev',
//     },
//     pagination: {
//         el: '.swiper-pagination',
//     },
//     watchOverflow: true
// })

// const sliderGaleryThumbs = new Swiper('.swiper-galery-thumbs', {
//     spaceBetween: 10,
//     slidesPerView: 4,
//     freeMode: true,
//     watchSlidesVisibility: true,
//     watchSlidesProgress: true,
//     navigation: {
//         nextEl: '.swiper-button-next-thumb',
//         prevEl: '.swiper-button-prev-thumb',
//     }
// })
// const sliderGalery = new Swiper('.swiper-galery', {
//     navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//     },
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
//     thumbs: {
//         swiper: sliderGaleryThumbs
//     }
// })

// const favoriteSlider = new Swiper('.swiper-favorites', {
//     slidesPerView: 1,
//     navigation: {
//         nextEl: '.btn-favorite-next',
//         prevEl: '.btn-favorite-prev',
//     },
//     observer: true,
//     observeParents: true,
//     breakpoints: {
//         992: {
//             spaceBetween: 30,
//             slidesPerView: 4
//         }
//     },
//     watchOverflow: true
// })
}

module.exports = {
  swipersInit
}
